// Hide 3 last replies
export const hideReplies = e => {
  const reply = e.target.parentNode;
  const replies = reply.querySelectorAll('.reply');
  const btnShow = reply.querySelector('.btnShow');
  replies.forEach((item, index) => {
    if (index > 1) {
      item.classList.add('hide');
    }
  });
  e.target.classList.add('hide');
  btnShow.classList.remove('hide');
};

// Show all replies
export const showReplies = e => {
  const reply = e.target.parentNode;
  const btnHide = reply.querySelector('.btnHide');
  const replies = reply.querySelectorAll('.reply');
  replies.forEach((item, index) => {
    if (index > 1) {
      item.classList.remove('hide');
    }
  });

  e.target.classList.add('hide');
  btnHide.classList.remove('hide');
};
